import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

// WOOLY : le prix affiché reste toujours le prix unitaire de la variante
// (pas de total des lots, pas de prix barré ni de badge liés aux quantités).
class ProductPrice extends HTMLElement {
  constructor() {
    super();
    this.productForm = null;
  }

  connectedCallback() {
    const scope = this.closest('product-card, [data-ref="product-section-content"], [data-ref="popup-content"]');
    this.productForm = scope?.querySelector('[data-ref="product-form"]');
    this.productForm?.addEventListener(ThemeEvents.variantUpdated, this.updateFromVariant);
  }

  disconnectedCallback() {
    this.productForm?.removeEventListener(ThemeEvents.variantUpdated, this.updateFromVariant);
  }

  updateFromVariant = (event) => {
    const variant = event.detail?.resource;
    if (!variant) return;

    const priceContainer = this.querySelector('[data-ref="price-container"]');
    if (priceContainer) {
      const price = variant.price;
      const compare = variant.compare_at_price || 0;

      const priceElement = priceContainer.querySelector('[data-ref="price"]');
      if (priceElement) priceElement.innerHTML = formatMoney(price);

      const compareEl = priceContainer.querySelector('[data-ref="compare-at-price"]');
      if (compareEl) compareEl.innerHTML = compare > price ? formatMoney(compare) : '';

      const diffEl = priceContainer.querySelector('[data-ref="difference-price-value"]');
      if (diffEl) {
        if (compare > price) {
          const prefix = diffEl.dataset.showMinus !== 'true' ? '-' : '';
          diffEl.innerHTML = this.dataset.salesBadge === 'percentage'
            ? `${prefix}${Math.round(((compare - price) * 100) / compare)}%`
            : `${prefix}${formatMoney(compare - price)}`;
        } else {
          diffEl.innerHTML = '';
        }
      }
    }

    const unitPriceElement = this.querySelector('[data-ref="unit-price"]');
    if (!unitPriceElement) return;
    if (!variant.unit_price_measurement) {
      unitPriceElement.innerHTML = '';
      return;
    }
    const { reference_value, reference_unit } = variant.unit_price_measurement;
    const reference = reference_value !== 1 ? `${reference_value} ${reference_unit}` : reference_unit;
    unitPriceElement.innerHTML = `${formatMoney(variant.unit_price)} / ${reference}`;
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
